<template>
    <tabs fill class="flex-column flex-md-row">
        <card shadow>
            <tab-pane>
            <span slot="title">
                Precious Plastic
            </span>
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <card class="border-0 mb-3" no-body shadow>

                            <img class="img-fluid"
                                 src="../assets/img/repo/precious_plastic/precious_plastic_machines.png">
                            <div class="px-3 mt-3 pb-3">
                                <h6 style="color: #f58d8e" class="text-uppercase">Machines</h6>
                                <p class="description mt-3"><a style="color: #f58d8e;"
                                                               href="https://preciousplastic.com"
                                                               target="_blank">Precious
                                    Plastic</a> have created machines that enable people to recycle and reuse plastic.
                                    These
                                    machines are modular, open source, and can be created by following a series of
                                    tutorials.
                                </p>

                                <base-button tag="a" href="https://preciousplastic.com/en/machines.html" target="_blank"
                                             style="background-color: #f58d8e; border: 1px solid #ff9495"
                                             class="mt-4 shadow text-white">
                                    Go to Machines
                                </base-button>
                            </div>
                        </card>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <card class="border-0 mb-3" no-body shadow>

                            <img class="img-fluid"
                                 src="../assets/img/repo/precious_plastic/precious_plastic_creations.png">
                            <div class="px-3 mt-3 pb-3">
                                <h6 style="color: #f58d8e" class="text-uppercase">Creations</h6>
                                <p class="description mt-3">Check out the creations provided by <a
                                        style="color: #f58d8e;"
                                        href="https://preciousplastic.com"
                                        target="_blank">Precious
                                    Plastic</a> and what you can make with a bit of creativity, some knowledge
                                    and a few tools.
                                </p>

                                <base-button tag="a" href="https://preciousplastic.com/en/creations.html" target="_blank"
                                             style="background-color: #f58d8e; border: 1px solid #ff9495"
                                             class="mt-4 shadow text-white">
                                    Go to Creations
                                </base-button>
                            </div>
                        </card>
                    </div>

                    <div class="col-md-4 col-sm-12">
                        <card class="border-0 mb-3" no-body shadow>
                            <img class="img-fluid"
                                 src="../assets/img/repo/precious_plastic/precious_plastic_bazar.jpg">
                            <div class="px-3 mt-3 pb-3">
                                <h6 style="color: #f58d8e" class="text-uppercase">Bazar</h6>
                                <p class="description mt-3">The Bazar is a place to sell, rent, swap and share goods,
                                    machines or services with other members of the Precious Plastic community.
                                </p>

                                <base-button tag="a" href="https://bazar.preciousplastic.com/" target="_blank"
                                             style="background-color: #f58d8e; border: 1px solid #ff9495"
                                             class="mt-4 shadow text-white">
                                    Go to Bazar
                                </base-button>
                            </div>
                        </card>
                    </div>
                </div>
            </tab-pane>
        </card>
    </tabs>
</template>
<script>
import Tabs from '@/components/Tabs/Tabs.vue'
import TabPane from '@/components/Tabs/TabPane.vue'

export default {
  name: 'external-sources',
  components: {
    TabPane,
    Tabs
  }
}
</script>
